const airColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '平均压力(MPa)',
    en: 'Average Pressure(MPa)',
    dataIndex: 'avgPressure',
    key: 'avgPressure',
    tooltip: true
  },
  {
    zh: '设定压力(MPa)',
    en: 'Rated Pressure(MPa)',
    dataIndex: 'ratedPressure',
    key: 'ratedPressure',
    tooltip: true
  },
  {
    zh: '平均频率(Hz)',
    en: 'Average Frequency(Hz)',
    dataIndex: 'avgFrequency',
    key: 'avgFrequency',
    tooltip: true
  },
  {
    zh: '上限频率(Hz)',
    en: 'Rated Frequency(Hz)',
    dataIndex: 'ratedFrequency',
    key: 'ratedFrequency',
    tooltip: true
  },
  {
    zh: '气量不足率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    fixed: 2
  }
]

export {
  airColumns
}
